import { getBrand } from '../helpers';
import { ClinicRequest, ClinicInfoServer, BrandParentUrl } from '../types';
import { getCorrelationId } from '../logging';

const MAX_DISTANCE = 200;

export const fetchClinic = async (
    clinicType: string,
    clinic: ClinicRequest,
    ehrServiceEndpoint: string,
    brandParentUrl: BrandParentUrl
): Promise<ClinicInfoServer[]> => {
    const brand = getBrand(brandParentUrl);
    const { zip } = clinic;
    let url = `${ehrServiceEndpoint}/?`;
    url += `clinicType=${clinicType}&`;

    if (brand) {
        if (clinicType === 'Retail') {
            // Swedish retail clinics are closed. Showing Prov for all retail
            url += 'brand=Providence&';
        } else {
            url += `brand=${brand}&`;
        }
    }
    if (zip) {
        url += `location=${zip}&distance=${MAX_DISTANCE}`;
    }

    // add event tracking
    return await (await fetch(url)).json();
};

export const getClinics = async (
    clinicType: string,
    clinic: ClinicRequest,
    ehrServiceEndpoint: string,
    brandParentUrl: BrandParentUrl
): Promise<ClinicInfoServer[]> => {
    const brand = getBrand(brandParentUrl);
    const { zip } = clinic;
    let url = `${ehrServiceEndpoint}?clinicType=${clinicType}&`;

    if (brand) {
        if (clinicType === 'Retail') {
            // Swedish retail clinics are closed. Showing Prov for all retail
            url += 'brand=Providence&';
        } else {
            url += `brand=${brand}&`;
        }
    }
    if (zip) {
        url += `location=${zip}&distance=${MAX_DISTANCE}`;
    }

    const correlationId = getCorrelationId();

    // add event tracking
    const resp = await fetch(url, {
        headers: { 'X-Request-ID': correlationId },
    });
    const clinics = await resp.json();
    // Following loop is here to mimic the old clinic fetching flow
    // This is a good candidate to refactor/fix
    for (const clinic of clinics) {
        clinic.waitTime = clinic.waittime;
    }
    return clinics;
};
